import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import List from './List/List'
import ThirdPartyAccessDialog from './Dialog/Dialog'
import HistoryDialog from './History/HistoryDialog'
import useThirdPartyAccess from '../../../../../hooks/setting/useThirdPartyAccess'

const isMaestroRole = (roles = []) => roles.some((r) => r?.id === 'Maestro')

const FULL_PERMISSION = {
  created: true,
  updated: true,
  deleted: true,
  sync: true,
  history: true
}

const ThirdPartyAccess = () => {
  const [type, setType] = useState(null)
  const [form, setForm] = useState(null)
  const [historyItem, setHistoryItem] = useState(null)

  const roles = useSelector((state) => state?.session?.user?.roles || [])
  const isMaestro = isMaestroRole(roles)
  const permObj = useSelector((state) => state?.session?.permissions?.['third-party-access'] || {})
  // Credenciales de servidor sensibles: acceso completo para Maestro; si no,
  // se respeta el permiso granular que exista.
  const permission = isMaestro ? FULL_PERMISSION : permObj

  const list = useSelector((state) => state?.tenant?.thirdPartyAccess || [])
  const { isLoadingList, sync } = useThirdPartyAccess()

  const onModal = (nextType = null, nextForm = {}) => {
    setType(nextType)
    setForm(nextForm)
  }

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Third party access
        </Typography>
        {!isLoadingList && permission['created'] && (
          <ButtonStartIcon
            onClick={() => onModal('create', {})}
            color='secondary'
            variant='contained'
            startIcon={['fas', 'plus']}
          >
            Add credential
          </ButtonStartIcon>
        )}
      </Box>
      <Box className='px-4 pt-3'>
        <Typography variant='caption' color='text.secondary'>
          Store the school&apos;s credentials for an external assessment provider (e.g. ACER OARS / PAT).
          Passwords are encrypted at rest and write-only — they are never shown again. Use <b>Sync</b> to pull
          the latest results.
        </Typography>
      </Box>
      <Box className='px-2 py-2'>
        <List
          isLoading={isLoadingList}
          list={list}
          permissions={permission}
          onModal={(t, f) => onModal(t, f)}
          onSync={sync}
          onHistory={(item) => setHistoryItem(item)}
        />
      </Box>
      {type && (
        <ThirdPartyAccessDialog
          type={type}
          show={!!type}
          onClose={() => onModal(null, {})}
          data={form || {}}
        />
      )}
      {historyItem && (
        <HistoryDialog show={!!historyItem} credential={historyItem} onClose={() => setHistoryItem(null)} />
      )}
    </>
  )
}

export default ThirdPartyAccess
